(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kz-editorial-care-guide"] && !Shopify.designMode) return;
  try {
    
(() => {
  const selector = '.kz-care video[data-kz-viewport-autoplay]';
  const videos = [...document.querySelectorAll(selector)];
  if (!videos.length) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  videos.forEach((video) => {
    video.muted = true;
    video.defaultMuted = true;
  });

  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  const pauseOthers = (activeVideo) => {
    videos.forEach((video) => {
      if (video !== activeVideo && !video.paused) video.pause();
    });
  };

  let activeCandidate = null;
  const playWhenReady = (video) => {
    activeCandidate = video;
    pauseOthers(video);

    const play = () => {
      if (activeCandidate !== video) return;
      video.play().catch(() => video.pause());
    };

    if (video.preload === 'none') video.preload = 'metadata';
    if (video.readyState >= 2) {
      play();
    } else {
      video.addEventListener('canplay', play, { once: true });
      video.load();
    }
  };

  const prepareObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const video = entry.target;
      video.preload = 'metadata';
      if (video.readyState === 0) video.load();
      observer.unobserve(video);
    });
  }, { rootMargin: '400px 0px', threshold: 0 });

  const playbackObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      const video = entry.target;
      if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
        playWhenReady(video);
      } else if (entry.intersectionRatio < 0.2 && !video.paused) {
        if (activeCandidate === video) activeCandidate = null;
        video.pause();
      }
    });
  }, { threshold: [0, 0.2, 0.55, 0.75] });

  videos.forEach((video) => {
    prepareObserver.observe(video);
    playbackObserver.observe(video);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
